<template lang="pug">
v-btn(fab small text @click="toggleFeatured" :disabled="loading")
    v-icon(v-if="item.featured === 1 && !loading" color="orange") mdi-star-settings
    v-icon(v-else-if="!loading" color="grey") mdi-star-settings-outline
    v-progress-circular(v-else indeterminate color="gray")
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            loading: false
        };
    },
    methods: {
        async toggleFeatured() {
            this.loading = true;
            try {
                const result = await this.findFeaturedMusic({
                    query: { music_id: this.item.id }
                });
                if(result.total === 0) {
                    await this.createFeatured({ music_id: this.item.id });
                } else {
                    await Promise.all(result.data.map(i => i.remove()));
                }
            } catch(err) {
                this.$emit('error', err);
                console.log(err);
            } finally {
                await this.getCampaign(this.item.id);
                this.loading = false;
            }
        },
        ...mapActions('bh-music-featured', { createFeatured: 'create', findFeaturedMusic: 'find' }),
        ...mapActions('vw-label-campaign', { getCampaign: 'get' })
    }
}
</script>